"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_PRESETS = void 0;
exports.calculateDateRange = calculateDateRange;
exports.DATE_PRESETS = [
    { key: "today", label: "Today", days: 0 },
    { key: "7d", label: "7 Days", days: 7 },
    { key: "14d", label: "14 Days", days: 14 },
    { key: "30d", label: "30 Days", days: 30 },
    { key: "90d", label: "90 Days", days: 90 },
    { key: "6m", label: "6 Months", days: 180 },
    { key: "1y", label: "1 Year", days: 365 },
    { key: "all", label: "All Time", days: -1 },
];
var formatLocalDate = function (date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");
    return "".concat(year, "-").concat(month, "-").concat(day);
};
var presetDays = {
    today: 0,
    "7d": 7,
    "14d": 14,
    "30d": 30,
    "90d": 90,
    "6m": 180,
    "1y": 365,
    all: -1,
};
function calculateDateRange(filters) {
    if (filters.custom) {
        return {
            start_date: formatLocalDate(filters.custom.start),
            end_date: formatLocalDate(filters.custom.end),
        };
    }
    var end = new Date();
    var start = new Date();
    var days = presetDays[filters.preset || "30d"];
    if (days === -1) {
        start.setFullYear(2020, 0, 1);
    }
    else if (days > 0) {
        start.setDate(end.getDate() - days);
    }
    return {
        start_date: formatLocalDate(start),
        end_date: formatLocalDate(end),
    };
}
